import { useLocation, useNavigate } from "react-router-dom";
import { useProductsContext } from "../context/ProductsProvider";
import Products, {SingleProduct} from "./Products";
import styles from "./Products.module.css";
import style from "./SingleProduct.module.css";
import {  CategorySlide, CategorySlideForMen, CategorySlideForWomen, MenShoesSubcategorySlide, MenBagsSubcategorySlide, WomenShoesSubcategorySlide, WomenBagsSubcategorySlide } from "./List";
import { FaArrowLeft } from 'react-icons/fa';
import  "./Slider.css";
import { Row, Col } from "react-bootstrap";

export function Product() {
  const navigate = useNavigate()
  const { state } = useProductsContext();
  const { state: routerState } = useLocation();

  // Check if routerState and routerState.id exist
  if (!routerState || !routerState.id) {
    console.warn('Invalid router state or missing id');
    navigate('/'); // Redirect to the home page or a relevant page
    return null;
  }
  const item = state.items.find((item) => item.id === routerState.id);

  if (!item) {
    console.warn('Item not found');
    navigate('/'); // Redirect to the home page or a relevant page
    return null;
  }
  
  return (
    <>
    <FaArrowLeft className="arrow_add" onClick={() => navigate("/")} />
      <div className={style.Single_body_container}>
        <SingleProduct {...item} />
      </div>
    </>
  );
}
/*-----------------------------------------------------------------------------------------
Products By Gender
-----------------------------------------------------------------------------------------*/
export function ProductsByGender({ gender }) {
  const { state } = useProductsContext();
  const filteredProducts = state.items.filter(
    (item) => item.gender === gender
  );

  return (
    <>
      <CategorySlide />
      <div className={styles.ProductsCategory}>
        <h4>All {`${gender}`} Products</h4>
      </div>
      <Row xs={2} md={3} lg={5} className={`g-0 `}>
        {filteredProducts.length > 0 ? (
          filteredProducts.map((item, index) => 
            <Col key={index} align="center">
              <Products key={item.id} {...item} />
            </Col>
          )
        ) : (
          <p className={styles.not_found}>No products found</p>
        )}
      </Row>
    </>
  );
}

export function Unisex() {
  return <ProductsByGender gender="unisex" />;
}

export function ProductsForMen() {
  const { state } = useProductsContext();
  // Filter products based on the category "Shoes"
  const productsForMen = state.items.filter((item) => item.gender === "Men");

  return (
    <>
      <CategorySlideForMen />
      <div className={styles.ProductsCategory}>
        <h4>All Men Products</h4>
      </div>
      <Row xs={2} md={3} lg={5} className={`g-0 `}>
        {productsForMen.length > 0 ? (
          productsForMen.map((item, index) =>
            <Col key={index} align="center">
              <Products key={item.id} {...item} />
            </Col>
          )
        ) : (
          <p className={styles.not_found}>No products found</p>
        )}
      </Row>
    </>
  );
}

export function ProductsForWomen() {
  const { state } = useProductsContext();
  // Filter products based on the category "Shoes"
  const productsForWomen = state.items.filter(
    (item) => item.gender === "Women"
  );

  return (
    <>
      <CategorySlideForWomen />
      <div className={styles.ProductsCategory}>
        <h4>All Women Products</h4>
      </div>
      <Row xs={2} md={3} lg={5} className={`g-0 `}>
        {productsForWomen.length > 0 ? (
          productsForWomen.map((item, index) =>
            <Col key={index} align="center">
              <Products key={item.id} {...item} />
            </Col>
          )
        ) : (
          <p className={styles.not_found}>No products found</p>
        )}
      </Row>
    </>
  );
}
/*-----------------------------------------------------------------------------------------
Products By Category
-----------------------------------------------------------------------------------------*/
export function ProductsByCategory({ category }) {
  const { state } = useProductsContext();
  const filteredProducts = state.items.filter(
    (item) => item.category === category
  );

  return (
    <>
      <CategorySlide />
      <div className={styles.ProductsCategory}>
        <h4> {`${category}`}</h4>
      </div>
      <Row xs={2} md={3} lg={5} className={`g-0 `}>
        {filteredProducts.length > 0 ? (
          filteredProducts.map((item, index) => 
            <Col key={index} align="center">
              <Products key={item.id} {...item} />
            </Col>
          )
        ) : (
          <p className={styles.not_found}>No products found</p>
        )}
      </Row>
    </>
  );
}

export function Jewellery() {
  return <ProductsByCategory category="Jewellery" />;
}

export function Glasses() {
  return <ProductsByCategory category="Glasses" />;
}

export function Watches() {
  return <ProductsByCategory category="Watches" />;
}

/*-----------------------------------------------------------------------------------------
Products By Category And Gender For Men
-----------------------------------------------------------------------------------------*/

export function ProductsByCategoryAndGender({ category, gender }) {
  const { state } = useProductsContext();
  const filteredProducts = state.items.filter(
    (item) => item.category === category && item.gender === gender
  );

  return (
    <>
   
      <div className={styles.ProductSub}>
        <h4>{`${category} For ${gender}`}</h4>
      </div>
      <Row xs={2} md={3} lg={5} className={`g-0 `}>
        {filteredProducts.length > 0 ? (
          filteredProducts.map((item, index) => 
            <Col key={index} align="center">
              <Products key={item.id} {...item} />
            </Col>
          )
        ) : (
          <p className={styles.not_found}>No products found</p>
        )}
      </Row>
    </>
  );
}

export function ShoesProductsForMen() {
  return (
      <>
        <ProductsByCategoryAndGender category="Shoes" gender="Men" />
        <br />
        <br />
        <MenShoesSubcategorySlide />
      </>
    );
}

export function WalletsProductsForMen() {
  return <ProductsByCategoryAndGender category="Wallets" gender="Men" />;
}

export function ClothesProductsForMen() {
  return <ProductsByCategoryAndGender category="Clothes" gender="Men" />;
}

export function BagsForMen() {
  return (
    <>
      <ProductsByCategoryAndGender category="Bags" gender="Men" />;
      <br />
      <br />
      <MenBagsSubcategorySlide />
    </>
)}

export function PerfumesForMen() {
  return <ProductsByCategoryAndGender category="Perfumes" gender="Men" />;
}

/*-----------------------------------------------------------------------------------------
Products By Category And Gender For Women
-----------------------------------------------------------------------------------------*/
export function ProductsByCategoryAndGenderForWomen ({ category, gender }) {
  const { state } = useProductsContext();
  const filteredProducts = state.items.filter(
    (item) => item.category === category && item.gender === gender
  );

  return (
    <>
      <div className={styles.ProductSub}>
        <h4>{`${category} For ${gender}`}</h4>
      </div>
      <Row xs={2} md={3} lg={5} className={`g-0 `}>
        {filteredProducts.length > 0 ? (
          filteredProducts.map((item, index) =>
            <Col key={index} align="center">
              <Products key={item.id} {...item} />
            </Col>
          )
        ) : (
          <p className={styles.not_found}>No products found</p>
        )}
      </Row>
    </>
  );
}

export function ShoesProductsForWomen() {
  return (
    <>
      <ProductsByCategoryAndGenderForWomen category="Shoes" gender="Women" />
      <WomenShoesSubcategorySlide />
    </>
)}

export function WalletsProductsForWomen() {
  return <ProductsByCategoryAndGenderForWomen category="Wallets" gender="Women" />;
}

export function ClothesProductsForWomen() {
  return <ProductsByCategoryAndGenderForWomen category="Clothes" gender="Women" />;
}

export function PerfumesForWomen() {
  return <ProductsByCategoryAndGenderForWomen category="Perfumes" gender="Women" />;
}

export function BagsForWomen() {
  return (
    <>
    <ProductsByCategoryAndGenderForWomen category="Bags" gender="Women" />
    <WomenBagsSubcategorySlide />
    </>
)}

/*-----------------------------------------------------------------------------------------
Shoes subcategories for men
-----------------------------------------------------------------------------------------*/

export function ShoesSubcategoryAndGenderForMen({ category, gender, subcategory }) {
  const { state } = useProductsContext();
  const filteredProducts = state.items.filter(
    (item) => item.category === category && item.gender === gender && item.subcategory === subcategory
  );

  return (
    <>
      <div className={styles.ProductSub}>
        <h4>{`${subcategory} For ${gender}`}</h4>
      </div>
      <Row xs={2} md={3} lg={5} className={`g-0 `}>
        {filteredProducts.length > 0 ? (
          filteredProducts.map((item, index) =>
            <Col key={index} align="center">
              <Products key={item.id} {...item} />
            </Col>
          )
        ) : (
          <p className={styles.not_found}>No products found</p>
        )}
      </Row>
    </>
  );
}

// Men’s shoes subcategory

export function LoafersForMen() {
  return( 
    <>
    <ShoesSubcategoryAndGenderForMen category="Shoes" gender="Men" subcategory="loafers" />
    <MenShoesSubcategorySlide />
    </>
)}

export function SneakersForMen() {
  return(
    <>
      <ShoesSubcategoryAndGenderForMen category="Shoes" gender="Men" subcategory="sneakers" />
      <MenShoesSubcategorySlide />
    </>
)}

export function SlidesForMen() {
  return(
    <>
      <ShoesSubcategoryAndGenderForMen category="Shoes" gender="Men" subcategory="slides" />
      <MenShoesSubcategorySlide />
    </>
)}

export function YeezysForMen() {
  return(
    <>
      <ShoesSubcategoryAndGenderForMen category="Shoes" gender="Men" subcategory="yeezys" />
      <MenShoesSubcategorySlide />
    </>
)}

// Men’s bags subcategory

export function MessengersForMen() {
  return(
    <>
      <ShoesSubcategoryAndGenderForMen category="Bags" gender="Men" subcategory="messengers" />
      <MenBagsSubcategorySlide />
    </>
)}

export function DufflesForMen() {
  return(
    <>
      <ShoesSubcategoryAndGenderForMen category="Bags" gender="Men" subcategory="duffles" />
      <MenBagsSubcategorySlide />
    </>
)}

export function BackPacksForMen() {
  return(
    <>
      <ShoesSubcategoryAndGenderForMen category="Bags" gender="Men" subcategory="back-packs" />
      <MenBagsSubcategorySlide />
    </>
)}

export function SlingsForMen() {
  return(
    <>
      <ShoesSubcategoryAndGenderForMen category="Bags" gender="Men" subcategory="slings" />
      <MenBagsSubcategorySlide />
    </>
)}

export function SatchelsForMen() {
  return(
    <>
      <ShoesSubcategoryAndGenderForMen category="Bags" gender="Men" subcategory="satchels" />
      <MenBagsSubcategorySlide />
    </>
)}

export function BeltBagsForMen() {
  return(
    <>
      <ShoesSubcategoryAndGenderForMen category="Bags" gender="Men" subcategory="belt-bags" />
      <MenBagsSubcategorySlide />
    </>
)}

// Women's shoes subcategory

export function EspadrillesForWomen() {
  return (
    <>
      <ShoesSubcategoryAndGenderForMen category="Shoes" gender="Women" subcategory="espadrilles" />
      <WomenShoesSubcategorySlide />
    </>

)}

export function SneakersForWomen() {
  return (
    <>
      <ShoesSubcategoryAndGenderForMen category="Shoes" gender="Women" subcategory="sneakers" />
      <WomenShoesSubcategorySlide />
    </>

)}

export function SlidesForWomen() {
  return (
    <>
      <ShoesSubcategoryAndGenderForMen category="Shoes" gender="Women" subcategory="slides" />
      <WomenShoesSubcategorySlide />
    </>

)}

export function HeelsForWomen() {
  return (
    <>
      <ShoesSubcategoryAndGenderForMen category="Shoes" gender="Women" subcategory="heels" />
      <WomenShoesSubcategorySlide />
    </>

)}

export function SandalsForWomen() {
  return (
    <>
      <ShoesSubcategoryAndGenderForMen category="Shoes" gender="Women" subcategory="sandals" />
      <WomenShoesSubcategorySlide />
    </>

)}

// Women's bags subcategory 

export function TotesForWomen() {
  return (
    <>
      <ShoesSubcategoryAndGenderForMen category="Bags" gender="Women" subcategory="totes" />
      <WomenBagsSubcategorySlide />
    </>

)}

export function ShoulderCrossBodyForWomen() {
  return (
    <>
      <ShoesSubcategoryAndGenderForMen category="Bags" gender="Women" subcategory="shoulder-cross-body" />
      <WomenBagsSubcategorySlide />
    </>

)}

export function MiniBagsForWomen() {
  return (
    <>
      <ShoesSubcategoryAndGenderForMen category="Bags" gender="Women" subcategory="mini-bags" />
      <WomenBagsSubcategorySlide />
    </>

)}

export function ClutchesForWomen() {
  return (
    <>
      <ShoesSubcategoryAndGenderForMen category="Bags" gender="Women" subcategory="clutches" />
      <WomenBagsSubcategorySlide />
    </>

)}